import React from "react";
import { DayPicker } from "./day_picker";

export interface DatePickerProps {
  testID?: string;
  value?: Date;
  onChange?: (value: Date) => void;
  isOutsideRange?: (date: Date) => boolean;
  isBlocked?: (date: Date) => boolean;
  numberOfMonths?: number;
  orientation?: "vertical" | "horizontal";
  allowBypassBlockedDates?: boolean;
}

export function DatePicker(props: DatePickerProps) {
  const {
    value,
    onChange = () => {},
    testID,
    isOutsideRange,
    isBlocked,
    numberOfMonths,
    orientation,
    allowBypassBlockedDates,
  } = props;

  return (
    <div data-component="DatePicker" data-testid={testID}>
      <DayPicker
        isRange={false}
        value={value}
        onChange={onChange}
        isBlocked={isBlocked}
        isOutsideRange={isOutsideRange}
        numberOfMonths={numberOfMonths}
        orientation={orientation}
        allowBypassBlockedDates={allowBypassBlockedDates}
      />
    </div>
  );
}
